import { useGlobalContext } from "./context/globalContext";
import React, { useState, useRef, useEffect } from "react";
import { FaMapLocation } from "react-icons/fa6";
import { MdHealthAndSafety, MdShoppingCart, MdSchool } from "react-icons/md";

const LocationBenefits2 = ({ project }) => {
  const { handleShowModal } = useGlobalContext();
  const [activeDetail, setActiveDetail] = useState(null);
  const detailsRef = useRef(null);

  // Handle click outside to close details
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click is outside both the details and the icon
      if (
        detailsRef.current &&
        !detailsRef.current.contains(event.target) &&
        !event.target.closest(".benefit-icon")
      ) {
        setActiveDetail(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Handle icon click
  const handleIconClick = (index, event) => {
    event.stopPropagation();
    setActiveDetail(activeDetail === index ? null : index);
  };

  const benefits = [
    {
      icon: <FaMapLocation />,
      title: "Connectivity",
      details: [
        "Western Express Highway - 500 m",
        "Upcoming Metro Station - 800 m",
        "Bandra Railway Station - 1.8 km",
        "BKC Business District - 2.2 km",
        "Bandra-Worli Sea Link - 3.5 km",
        "Airport (CSMIA) - 6.5 km",
      ],
    },
    {
      icon: <MdSchool />,
      title: "Education",
      details: [
        "St. Paul's Scl - 1.7 km",
        "DB Ambani Intl. Scl - 4.5 km",
        "St. Andrews High Scl - 2.2 km",
      ],
    },
    {
      icon: <MdHealthAndSafety />, // Replace with your chosen icon
      title: "Healthcare",
      details: [
        "Asian Heart Institute - 2.5 km",
        "Bhabha Hospital - 3.2 km",
        "Lilavati Hospital - 3.9 km",
      ],
    },
    {
      icon: <MdShoppingCart />, // Replace with your chosen icon
      title: "Retail & Leisure",
      details: [
        "Jio World Drive - 2.4 km ",
        "Phoenix Marketcity Kurla - 8.8 km",
        "Phoenix Palladium - 10 km",
        "Jio World Plaza - 4.4 km",
      ],
    },
  ];
  return (
    <>
      <div className="section shadow-sm lazyloaded">
        <div className="lb-container">
          <div className="lb-map">
            <img src="/images/lb.PNG" alt="Location Overview" />
          </div>
          <div className="lb-content">
            <div className="lb-content-body">
              <h2 className="head text-capitalize text-center">
                {project} - Location & Connectivity
              </h2>
              <div className="cards">
                {benefits.map((benefit, index) => (
                  <div
                    key={index}
                    className={`crd position-${index + 1}  ${
                      activeDetail === index ? "alive-card" : ""
                    } `}
                  >
                    <div
                      className="crd-icon"
                      onClick={(e) => handleIconClick(index, e)}
                    >
                      {benefit.icon}
                      <span className="crd-title">{benefit.title}</span>
                    </div>
                    <div
                      ref={activeDetail === index ? detailsRef : null}
                      className={`crd-details ${
                        activeDetail === index ? "active" : ""
                      }`}
                      id="card-details-scroll"
                    >
                      <ul>
                        {/* {benefit.details.map((detail, idx) => (
                          <li key={idx}>{detail}</li>
                        ))} */}
                        {benefit.details.map((detail, idx) => {
                          const parts = detail.split(" - "); // Using " - " (en dash) for separation
                          if (parts.length === 2) {
                            return (
                              <li key={idx}>
                                <span>{parts[0]}</span>
                                <span>{parts[1]}</span>
                              </li>
                            );
                          } else {
                            return <li key={idx}>{detail}</li>; // Handle cases with no " - "
                          }
                        })}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="lb-content-footer">
              <span
                className="new-button "
                onClick={() => handleShowModal("Location Benefits")}
              >
                <span className="new-button-inner">
                  <span className="underline-animation">Get All Details</span>
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default LocationBenefits2;
